import { useRecoilValue } from "recoil";
import { userInfoAtom } from "../../atoms";
import { DiscoverBrands } from "./components/DiscoverBrands";
import { DiscoverCreators } from "./components/DiscoverCreators";

export default function DiscoverPage() {
  const userInfo = useRecoilValue(userInfoAtom);
  const isBrand = !!userInfo?.brandId;

  return isBrand ? <DiscoverCreators /> : <DiscoverBrands />;
}
